import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { VideoFrame } from "./types";

interface ScrollingTimelineProps {
  videos: VideoFrame[];
  currentVideoIndex: number;
  framesPath: string;
  onVideoSelect: (index: number) => void;
  disabled?: boolean;
}

export default function ScrollingTimeline({
  videos,
  currentVideoIndex,
  framesPath,
  onVideoSelect,
  disabled = false,
}: ScrollingTimelineProps) {
  const getThumbnailSrc = (video: VideoFrame): string => {
    return `${framesPath}/${video.startFrame}`;
  };

  return <div>Timeline</div>;
}
